export default __webpack_public_path__ + "static/media/SneakerSwipe3.eccbf9ea.png";